import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { stripRem } from '../../utils/size-manipulation.js';
import 'react';
import { useTheme } from '../../utils/hooks/use-theme.js';
import { LogoSvg } from './logo.style.js';
import randomKey from '../../node_modules/@arcadiapower/warbler/dist/number/random-key.js';

const Logo = props => {
    const { className = '', margin, scale = 5, type = 'circle', variant = 'default' } = props, rest = __rest(props, ["className", "margin", "scale", "type", "variant"]);
    const theme = useTheme();
    const iconSize = stripRem(theme.iconSizes.step) * scale;
    const getFill = (isContentPath) => {
        const colors = theme.logos.variantColorMap[variant];
        if (!isContentPath) {
            return theme.colors.content[colors.background];
        }
        else {
            // casting here because we know `colors.content` is defined because of
            // how this function is used; need to cast to tell TS that.
            // would probably be better to rewrite this with some typeguards instead of `isContentPath`
            return theme.colors.content[colors.content];
        }
    };
    const getPaths = ({ isContentPath = false, paths, }) => paths.map(path => (jsx("path", { d: path, fill: getFill(isContentPath), fillRule: "evenodd", clipRule: "evenodd" }, `${path}-${randomKey()}`)));
    const useContentlessPath = type === 'name' ||
        type === 'node' ||
        variant === 'light' ||
        variant === 'accent';
    const path = theme.logos.paths[type];
    const logoPaths = useContentlessPath ? (getPaths({ paths: path.contentless })) : (jsxs(Fragment, { children: [getPaths({
                paths: path.withContent.background,
            }), getPaths({
                isContentPath: true,
                paths: path.withContent.content,
            })] }, void 0));
    const viewBox = type === 'name' ? `0 0 244 56` : `0 0 56 56`;
    return (jsx(LogoSvg, Object.assign({ className: className, viewBox: viewBox, margin: margin, height: `${iconSize}rem`, fill: "none", xmlns: "http://www.w3.org/2000/svg", shapeRendering: "auto" }, rest, { children: logoPaths }), void 0));
};

export { Logo };
